module.exports = __webpack_public_path__ + "static/img/21321321.87a62b27.png";